/**
 * Runtime config from env chunk (window.MLBBest.envVariables).
 * Aligns with blue-ui: one build, env chosen by which index-{env}.html is loaded.
 */
const getEnv = () => {
  if (typeof window !== "undefined" && window.MLBBest?.envVariables) {
    return window.MLBBest.envVariables;
  }
  return {};
};

export const getEnvVar = (key) => getEnv()[key] ?? "";

export default getEnv;
